// src/config/firebase.ts
import { initializeApp, FirebaseApp } from "firebase/app";
import { getAuth, connectAuthEmulator, Auth } from "firebase/auth";
import logger from '../utils/logger';
// Import other Firebase services like getFirestore if needed

// Your web app's Firebase configuration
// IMPORTANT: Use environment variables for these values!
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  // measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID // Optional
};

// Initialize Firebase
let firebaseApp: FirebaseApp;
let firebaseAuth: Auth;

try {
  firebaseApp = initializeApp(firebaseConfig);
  firebaseAuth = getAuth(firebaseApp);
  logger.debug("Firebase initialized successfully.");

  // Connect to emulators in development
  logger.debug("\tConnect to Firebase emulator ...");
  if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
    // Make sure the port matches your firebase.json auth emulator port
    connectAuthEmulator(firebaseAuth, `http://localhost:${process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_PORT || 9099}`);

    // Example for Firestore emulator:
    // const firestore = getFirestore(app);
    // connectFirestoreEmulator(firestore, "localhost", 8080); // Default Firestore emulator port

    // Add other emulator connections here if needed
    logger.info("Firebase Auth emulator connected.");
  }

} catch (error) {
  console.error("Firebase initialization error:", error);
  // Handle initialization error appropriately
}

export { firebaseApp, firebaseAuth }; // Export the initialized app and auth instances
